import { lazy, Suspense } from 'react';
import Fallback from '../custom/fallback/fallback';
import DashboardLayout from "./dashboardLayout/dashboardLayout";
const Main = lazy(() => import('../components/trainingPayment/main'));

const TrainingPayment = () => {
    return (
        <DashboardLayout 
            heading="Training Payment"
        >
            <Suspense fallback={<Fallback />}>
                <Main />
            </Suspense>

            
        </DashboardLayout>
    );
};

export default TrainingPayment;